<template>
  <section class="mode" id="mode">
    <div class="row">
      <div class="col-lg-5">
        <div class="mode-info">
          <h1 style="font-weight: bold;">{{ messages.mode.title }}</h1>
          <h1 class="info">{{ messages.mode.title1 }}</h1>
          <h1 class="info-hand">
            <a v-bind:href="messages.mode.href" target="_blank">
              {{ messages.mode.text1 }}
              <div class="hand">
                <img v-bind:src="require('./../assets/img/hand.svg')"/>
              </div>
            </a>
          </h1>
          <div class="content">
            {{ messages.mode.text2 }}
          </div>
        </div>
      </div>
      <div class="col-lg-7 switch-hand">
        <div class="switch">
          <input type="checkbox" id="mode_check" v-on:change="mode_on()" v-model="mode"/><label for="mode_check">Toggle</label>
        </div>
        <hr>
        <div class="hand">
          <img v-bind:src="require('./../assets/img/hand.svg')"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "mode_component",
  data(){
    return {
      messages: {},
      mode: false
    };
  },
  methods:{
    mode_on(){
      if(this.mode){
        document.getElementById("mode").classList.add("on");
        document.getElementById("mode").classList.add("fade");
      }else{
        document.getElementById("mode").classList.remove("on");
        document.getElementById("mode").classList.remove("fade");
      }
    }
  },
  beforeMount() {
    this.messages = window.messages;
  }
}
</script>

<style scoped>

</style>